export enum CardState {
    INVALID = 'INVALID',
    VALID = 'VALID',
    EMPTY = 'EMPTY',
}
